import React, { useEffect, useState } from 'react';
import api from '../api';

const PRESETS = [
  { command: 'yardim',   description: 'Yardım mesajı',      response: '❓ <b>Yardım</b>\n\nBotun kullanımı hakkında bilgi almak için aşağıdaki komutları kullanabilirsin:\n\n/start - Botu başlatır\n/yardim - Bu mesajı gösterir\n/destek - Destek talebi oluşturur' },
  { command: 'hakkinda', description: 'Bot hakkında bilgi', response: 'ℹ️ <b>Hakkımda</b>\n\nBu bot [bot adı] tarafından geliştirilmiştir.\n\nHerhangi bir sorun için /destek komutunu kullanabilirsin.' },
  { command: 'politika', description: 'Gizlilik politikası', response: '📜 <b>Gizlilik Politikası</b>\n\nKişisel verileriniz güvenle saklanmaktadır.\n\nDaha fazla bilgi için destek ekibimizle iletişime geçin.' },
  { command: 'destek',   description: 'Destek bilgisi',     response: '🆘 <b>Destek</b>\n\nDestek için:\n• @destekkullanici ile iletişime geç\n• Email: destek@example.com' },
  { command: 'bilgi',    description: 'Bot bilgisi',        response: 'ℹ️ <b>Bot Bilgisi</b>\n\nBu bot [işlev] için tasarlanmıştır.\n\nKomutlar için /yardim yazabilirsin.' },
];

export default function BotCommands({ botId, botName }) {
  const [commands, setCommands] = useState([]);
  const [showForm, setShowForm]   = useState(false);
  const [editCmd, setEditCmd]     = useState(null);
  const [loading, setLoading]     = useState(false);
  const [toast, setToast]         = useState('');

  const emptyForm = { command: '', response: '', description: '', parse_mode: 'HTML' };
  const [form, setForm] = useState(emptyForm);

  useEffect(() => { if (botId) loadCommands(); }, [botId]);

  async function loadCommands() {
    try { const r = await api.get(`/bot-commands/${botId}`); setCommands(r.data); }
    catch(e) {}
  }

  function showToast(msg) { setToast(msg); setTimeout(() => setToast(''), 3000); }

  async function submitForm(e) {
    e.preventDefault(); setLoading(true);
    try {
      if (editCmd) {
        await api.put(`/bot-commands/${botId}/${editCmd.id}`, form);
        showToast('✅ Komut güncellendi');
      } else {
        await api.post(`/bot-commands/${botId}`, form);
        showToast('✅ Komut eklendi');
      }
      setShowForm(false); setEditCmd(null); setForm(emptyForm);
      loadCommands();
    } catch(ex) { showToast('❌ ' + (ex.response?.data?.error || ex.message)); }
    setLoading(false);
  }

  async function toggleCmd(cmd) {
    try {
      await api.put(`/bot-commands/${botId}/${cmd.id}`, { is_active: !cmd.is_active });
      loadCommands();
    } catch(e) {}
  }

  async function deleteCmd(cmd) {
    if (!window.confirm(`/${cmd.command} silinsin mi?`)) return;
    try { await api.delete(`/bot-commands/${botId}/${cmd.id}`); loadCommands(); }
    catch(e) { showToast('❌ Hata: ' + e.message); }
  }

  function openEdit(cmd) {
    setForm({ command: cmd.command, response: cmd.response, description: cmd.description || '', parse_mode: cmd.parse_mode || 'HTML' });
    setEditCmd(cmd);
    setShowForm(true);
  }

  function addPreset(preset) {
    const exists = commands.find(c => c.command === preset.command);
    if (exists) { openEdit(exists); return; }
    setForm({ command: preset.command, response: preset.response, description: preset.description, parse_mode: 'HTML' });
    setEditCmd(null);
    setShowForm(true);
  }

  const inp = { className: 'input', style: { fontSize: 13 } };

  return (
    <div>
      {/* Toast */}
      {toast && (
        <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, background: toast.startsWith('❌') ? '#fef2f2' : '#f0fdf4', color: toast.startsWith('❌') ? '#dc2626' : '#166534', border: `1px solid ${toast.startsWith('❌') ? '#fca5a5' : '#bbf7d0'}`, borderRadius: 8, padding: '10px 18px', fontSize: 13, fontWeight: 600 }}>{toast}</div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 13, color: 'var(--text3)' }}>{commands.length} komut tanımlı</div>
        <button className="btn btn-primary btn-sm" onClick={() => { setEditCmd(null); setForm(emptyForm); setShowForm(true); }}>+ Komut Ekle</button>
      </div>

      {/* Hazır şablonlar */}
      <div style={{ background: 'var(--surface2)', borderRadius: 'var(--radius-sm)', padding: 14, marginBottom: 16 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text3)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: .5 }}>⚡ Hazır Komutlar</div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {PRESETS.map(p => {
            const added = commands.some(c => c.command === p.command);
            return (
              <button key={p.command} onClick={() => addPreset(p)}
                style={{ padding: '4px 12px', borderRadius: 20, border: '1px solid var(--border)', cursor: 'pointer', fontSize: 12, background: added ? 'var(--accent-s)' : 'var(--surface)', color: added ? 'var(--accent)' : 'var(--text2)' }}>
                {added ? '✓ ' : ''}/{p.command}
              </button>
            );
          })}
        </div>
      </div>

      {/* Komut listesi */}
      {commands.length === 0 && (
        <div style={{ textAlign: 'center', padding: 30, color: 'var(--text3)', fontSize: 13 }}>
          Henüz komut eklenmedi. Hazır şablonlardan seç veya manuel ekle.
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {commands.map(cmd => (
          <div key={cmd.id} style={{ background: 'var(--surface2)', border: '1px solid var(--border3)', borderRadius: 'var(--radius-sm)', padding: '12px 14px', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <code style={{ fontSize: 14, fontWeight: 700, color: 'var(--accent)', background: 'var(--accent-s)', padding: '2px 8px', borderRadius: 6 }}>/{cmd.command}</code>
                {cmd.description && <span style={{ fontSize: 12, color: 'var(--text3)' }}>{cmd.description}</span>}
                {!cmd.is_active && <span style={{ fontSize: 11, color: '#64748b', background: 'rgba(100,116,139,.15)', padding: '1px 6px', borderRadius: 10 }}>Pasif</span>}
              </div>
              <div style={{ fontSize: 12, color: 'var(--text2)', whiteSpace: 'pre-wrap', maxHeight: 60, overflow: 'hidden', textOverflow: 'ellipsis', background: 'var(--surface3)', padding: '6px 10px', borderRadius: 6 }}>
                {cmd.response.replace(/<[^>]+>/g, '').slice(0, 120)}{cmd.response.length > 120 ? '...' : ''}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 5, flexShrink: 0 }}>
              <button className="btn btn-ghost btn-sm" onClick={() => openEdit(cmd)}>✏️</button>
              <button className="btn btn-ghost btn-sm" onClick={() => toggleCmd(cmd)}>{cmd.is_active ? '⏸' : '▶️'}</button>
              <button className="btn btn-danger btn-sm" onClick={() => deleteCmd(cmd)}>🗑️</button>
            </div>
          </div>
        ))}
      </div>

      {/* Form Modal */}
      {showForm && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowForm(false)}>
          <div className="modal" style={{ maxWidth: 520 }}>
            <h3>{editCmd ? '✏️ Komut Düzenle' : '➕ Yeni Komut'}</h3>
            <form onSubmit={submitForm}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div className="input-group">
                  <label>Komut (/ olmadan)</label>
                  <input {...inp} value={form.command} onChange={e => setForm(p => ({ ...p, command: e.target.value.replace(/^\//, '').toLowerCase() }))} placeholder="politika" required/>
                </div>
                <div className="input-group">
                  <label>Açıklama (opsiyonel)</label>
                  <input {...inp} value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))} placeholder="Gizlilik politikası"/>
                </div>
              </div>

              <div className="input-group">
                <label>
                  Yanıt Metni
                  <span style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 'normal', marginLeft: 8 }}>HTML: &lt;b&gt;, &lt;i&gt;, &lt;a href=""&gt;</span>
                </label>
                <textarea className="input" value={form.response} onChange={e => setForm(p => ({ ...p, response: e.target.value }))} style={{ minHeight: 160, fontSize: 13, fontFamily: 'monospace' }} placeholder="❓ <b>Yardım</b>&#10;&#10;Bot kullanımı..." required/>
              </div>

              <div className="input-group" style={{ marginBottom: 0 }}>
                <label>Parse Mode</label>
                <select className="input" style={{ fontSize: 13 }} value={form.parse_mode} onChange={e => setForm(p => ({ ...p, parse_mode: e.target.value }))}>
                  <option value="HTML">HTML</option>
                  <option value="Markdown">Markdown</option>
                  <option value="">Düz Metin</option>
                </select>
              </div>

              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
                <button type="button" className="btn btn-ghost" onClick={() => { setShowForm(false); setEditCmd(null); }}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? '⏳...' : editCmd ? '💾 Kaydet' : 'Ekle'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
